// Third-party imports
import $ from 'jquery';

// Local imports
import { cartUpdateHandler, isCartUpdating } from '../../basket/quantity.js';
import { isBasketPage } from '../../basket/init.js';
import {
    popUpClosingEventHandler,
    checkIfDoesNotExceedMaxQuantity,
} from '../../gift_catalogue/logic/check_max_quantity.js';
import { buttonStateHandler } from '../../gift_catalogue/logic/button_handler.js';
import {
    maxQuantityHandler,
    isInventoryTracked,
} from './merchandise_control.js';

// Module vars
export const MODULE_NAME = 'product_quantity';

export let global_vars = {};

// global arg is expected to be the window object when run in a browser
export function initialize(global) {
    let incrementerActionButton = '.js-quantityIncrementer-action';
    let incrementerSetterInputField = '.js-quantityIncrementer-setter';
    if (incrementerActionButton.length === 0) {
        return;
    }
    incrementerInitializer(global, incrementerActionButton);
    counterSetterInitializer(global, incrementerSetterInputField);
    popUpClosingEventHandler();
}

export function dynamic_initialize(global, node) {
    let incrementerActionButton = '.js-quantityIncrementer-action';
    incrementerInitializer(global, incrementerActionButton, node);
}

function qtyEvent() {
    // The following only applies to OGC re-designed pages.
    // we wrap this functionality inside an IF statement with an element
    // that only appears on the re-designed product page.
    let viewButton = $('#view_basket');
    let initialQty = 0;
    if (!viewButton) {
        return;
    }
    let variantId = $('.js-variantID-hook');
    if (variantId) {
        if ($('#variant_id_' + variantId.val()))
            initialQty = $('#variant_id_' + variantId.val()).attr(
                'data-quantity'
            );
    }

    let qtyInput = $('#productGCQuantityField');
    if (viewButton && qtyInput) {
        let add_button = $('#to_cart');
        if (initialQty) {
            if (initialQty !== qtyInput.val()) {
                $('.qtyChange-hook').show();
                viewButton.addClass('button--removed');
                add_button.removeClass('button--removed');
            } else {
                $('.qtyChange-hook').hide();
                viewButton.removeClass('button--removed');
                add_button.addClass('button--removed');
            }
        }
    }
}

// global arg is expected to be the window object when run in a browser
function incrementerInitializer(global, incrementerActionButton, element) {
    // The original implementation was using jquery's $.on() function but this
    // was proving to be unreliable. An alternative implementation in vanilla js
    // is used here for reliability.
    let base_el = element !== undefined ? element : global.document;
    let matches = base_el.querySelectorAll(incrementerActionButton);
    for (let el of matches) {
        el.addEventListener('click', event => {
            onIncrementDecrementClicked.call(event.target, global);
            qtyEvent();
        });
    }
}

function counterSetterInitializer(global, incrementerSetterInputField) {
    let matches = global.document.querySelectorAll(incrementerSetterInputField);
    for (let el of matches) {
        el.addEventListener('keyup', event => {
            onQuantityInputHandler.call(event, global);
            if (!isBasketPage()) {
                qtyEvent();
            }
        });
        if (isBasketPage()) {
            applyMaxLimit(el);
            el.addEventListener('blur', event => {
                onQuantityBlurHandler.call(event.target, global);
            });
        } else {
            // adding new event listener to qty input on product page
            el.addEventListener('keydown', event => {
                onQuantityInputHandler.call(event, global);
                qtyEvent();
            });
        }
    }
}

// When the basket page loads, we need to add a max attribute to the input
// field IF the product is tracking inventory. This needs to be dynamic because
// if there is a max value, then the parsley error will say that the input value
// needs to be between 0 and the max... but if the product is not being tracked,
// then that message is invalid. So we remove the max attribute so that the error
// states that the value needs to be greater than 0
function applyMaxLimit(element) {
    if (element.dataset.inventoryTracked === 'true') {
        let max = parseInt(element.dataset.maxInventory);
        element.setAttribute('max', max);
    }
}

function onIncrementDecrementClicked(global) {
    incrementingDependingOnTemplate.call(this, global);
}

// Blur handler for the quantity input on the basket page
function onQuantityBlurHandler(global) {
    incrementingDependingOnTemplate.call(this, global);
}

function onQuantityInputHandler(global) {
    if (isBasketPage()) {
        if (this.key === 'Escape') {
            onResetCounterToInitial.call(this.target);
        } else if (this.key === 'Enter') {
            incrementingDependingOnTemplate.call(this.target, global);
        }
    } else {
        // Pass the input counter value through the process to ensure that it's
        // within the max quantity and can be submitted
        incrementingDependingOnTemplate.call(this.target, global);
        // Update the add to cart button based on the input counter value
        buttonStateHandler();
    }
}

// Reset the counter value to the initial value when we loaded the page
// This is only in the basket page
function onResetCounterToInitial() {
    let initialQuantity = parseInt($(this).data('initialAmount'));
    $(this).val(initialQuantity);
    $(this).blur();
}

function incrementingDependingOnTemplate(global) {
    // Element with the quantity dataset
    let pdpQuantityInput = $('.js-quantity-hook');
    // An object with the counter element and the PRE event counter value
    let counterObject = counterObjectBuilder.call(this);
    // Used to know if we are incrementing or decrementing the counter value
    let actionClass = $(this).data('increment-action');
    // The value of the counter POST increment/decrement event
    let counterValue = quantityModifier(
        actionClass,
        counterObject.counterValue,
        pdpQuantityInput
    );
    if (isBasketPage()) {
        if (!isCartUpdating.call(this)) {
            checkOnQuantity.call(
                this,
                global,
                actionClass,
                counterObject.counterElement,
                counterValue
            );
        }
    } else if (pdpQuantityInput.length > 0) {
        checkIfDoesNotExceedMaxQuantity(
            pdpQuantityInput,
            counterObject.counterElement,
            counterObject.counterValue,
            counterValue
        );
    } else {
        counterObject.counterElement.val(counterValue);
    }
}

function checkOnQuantity(global, actionClass, counterElement, counterValue) {
    let preCounterValue = counterElement.val();
    let inventoryTracked = isInventoryTracked(counterElement);
    let initialQuantity = parseInt(counterElement.data('initialAmount'));
    // With the input type text, we need to revert the value of the field
    // to the initial quantity if the input is invalid (NaN)
    if (isNaN(counterValue)) {
        counterValue = initialQuantity;
    }

    counterElement.val(counterValue);
    // We manually run parsley validation on products that have inventory tracking
    // in order to see the error popup.
    if (inventoryTracked || counterValue < 0) {
        $(counterElement)
            .parsley()
            .validate();
    }

    // We are also manually verifying the input value in the maxQuantityHandler call
    // If the product does not track inventory and the input value is valid, we can update the
    // cart with the new value. If either of those evaluate false, we need to run the value
    // through the max quantity handler, which will clamp the value between 0 and max (if there is one)
    if (
        (!inventoryTracked && counterValue > 0) ||
        maxQuantityHandler.call(
            this,
            actionClass,
            counterElement,
            counterValue,
            preCounterValue
        )
    ) {
        if (counterValue !== initialQuantity) {
            cartUpdateHandler.call(this, global);
        }
    }
}

export function counterObjectBuilder() {
    let componentWrapper = $(this).closest(
        '.js-quantityIncrementer-componentWrapper'
    );
    let counterElement = componentWrapper.find(
        '.js-quantityIncrementer-counter'
    );
    let counterValue = parseInt(counterElement.val());
    return { counterElement: counterElement, counterValue: counterValue };
}

function quantityModifier(actionClass, counterValue) {
    if (actionClass === 'increase') {
        counterValue++;
    } else if (actionClass === 'decrease' && counterValue !== 0) {
        counterValue = counterValue - 1;
    }
    return counterValue;
}
